import { Link } from "react-router-dom";
import "./CardGrid.css";

export default function CardGrid({ items }) {
  return (
    <section className="grid">
      {items.map((item) => {
        // Determine CTA
        const cta = item.cta || { label: "Inquire", href: "/contact" };

        // Determine Read More route
        let readMoreLink = null;
        if (item.longDescription) {
          if (item.type === "hotels") {
            readMoreLink = `/hotels/${item.id}`;
          } else if (item.category && item.id) {
            readMoreLink = `/packages/${item.category}/${item.id}`;
          }
        }

        return (
          <article key={item.id} className="card">
            {/* Image */}
            {item.image ? (
              <img src={item.image} alt={item.title} className="card-image" />
            ) : (
              <div className="card-placeholder">No image</div>
            )}

            {/* Body */}
            <div className="card-body">
              <h3>{item.title}</h3>
              {item.location && <p className="muted">📍 {item.location}</p>}

              {/* Short description only */}
              <p>{item.shortDescription || item.description}</p>

              {/* Rating */}
              {item.rating && (
                <div className="rating">
                  {[...Array(5)].map((_, i) => (
                    <span
                      key={i}
                      className={`star ${i < item.rating ? "filled" : ""}`}
                    >
                      ★
                    </span>
                  ))}
                </div>
              )}

              {/* Actions */}
              <div className="card-actions">
                {readMoreLink ? (
                  <Link className="btn" to={readMoreLink}>
                    Read More
                  </Link>
                ) : cta.href.startsWith("/") ? (
                  <Link className="btn" to={cta.href}>
                    {cta.label}
                  </Link>
                ) : (
                  <a
                    className="btn"
                    href={cta.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {cta.label}
                  </a>
                )}
              </div>
            </div>
          </article>
        );
      })}
    </section>
  );
}
